

















import Vue from 'vue';
import OrderableProductCard from '@/components/v2/orderable-product/OrderableProductCard.vue';
import AppSlider from '@/components/v2/slider/Slider.vue';
import SwiperSlide from '@/components/v2/slider/SwiperSlide.vue';
import DesktopMobileSwitch from '@/components/v2/mobile-desktop-switch/MobileDesktopSwitch.vue';

export default Vue.extend({
    name: 'ProductShelf',
    components: {
        AppSlider,
        SwiperSlide,
        'desktop-mobile-switch' : DesktopMobileSwitch,
        'orderable-product-card': OrderableProductCard
    },
    data() {
        return {
            breakpoints: {
                480: {slidesPerView: 1.8},
                768: {slidesPerView: 2.8},
                1024: {slidesPerView: 3.8},
                1280: {slidesPerView: 5}
            }
        }
    },
    props: {
        productKeys: {
            type: Array,
            required: true
        },
    },
    methods: {},
    computed: {},
    mounted() {

    }
});
